import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=beb859f6&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=beb859f6&prod&lang=scss"
import style1 from "./Footer.vue?vue&type=style&index=1&id=beb859f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb859f6",
  null
  
)

export default component.exports